import { render, staticRenderFns } from "./Mancheta.vue?vue&type=template&id=de886274&scoped=true"
import script from "./Mancheta.vue?vue&type=script&lang=js"
export * from "./Mancheta.vue?vue&type=script&lang=js"
import style0 from "./Mancheta.vue?vue&type=style&index=0&id=de886274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de886274",
  null
  
)

export default component.exports